/*
  Style swatches on product cards (snippets/product-card-style-swatches.liquid).
  Hover/focus a swatch to preview that colorway's image on the card; click navigates (plain link).
  Uses document-level delegation so cards added later (filters, pagination, recommendations) work too.
*/
(() => {
  if (window.__kaneStyleSwatches) return;
  window.__kaneStyleSwatches = true;

  const getPrimaryImage = (card) => card.querySelector('.product-card__image--primary');

  const preview = (swatch) => {
    const card = swatch.closest('product-card');
    const img = card && getPrimaryImage(card);
    if (!img || !swatch.dataset.hoverSrc) return;

    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.getAttribute('src') || '';
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }

    img.setAttribute('srcset', swatch.dataset.hoverSrcset || '');
    img.setAttribute('src', swatch.dataset.hoverSrc);
    card.classList.add('is-previewing-swatch');
  };

  const restore = (swatch) => {
    const card = swatch.closest('product-card');
    const img = card && getPrimaryImage(card);
    if (!img || img.dataset.originalSrc === undefined) return;

    img.setAttribute('srcset', img.dataset.originalSrcset);
    img.setAttribute('src', img.dataset.originalSrc);
    card.classList.remove('is-previewing-swatch');
  };

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('pointerover', (event) => {
    if (!canHover.matches) return;
    const swatch = event.target.closest?.('.style-swatch[data-hover-src]');
    if (swatch && !swatch.contains(event.relatedTarget)) preview(swatch);
  });

  document.addEventListener('pointerout', (event) => {
    if (!canHover.matches) return;
    const swatch = event.target.closest?.('.style-swatch[data-hover-src]');
    if (swatch && !swatch.contains(event.relatedTarget)) restore(swatch);
  });

  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest?.('.style-swatch[data-hover-src]');
    if (swatch) preview(swatch);
  });

  document.addEventListener('focusout', (event) => {
    const swatch = event.target.closest?.('.style-swatch[data-hover-src]');
    if (swatch) restore(swatch);
  });
})();
